import React from 'react';
import { useLocation } from 'react-router-dom';
import { ALL_EMAIL_LOGS } from '../../graphql/emailLogs';
import Paginator from '../Paginator';
import { parsePaging, parseSorting } from '../../utils/queryString';
import Spinner from '../Spinner';
import useExtendedQuery from '../../hooks/useExtendedQuery';
import Error from '../errors/Error';
import EmailLogsList from './EmailLogsList';
import Constants from '../../utils/Constants';

const LOG_SORT_KEYS = ['dateTime', 'subject', 'recipients', 'status', 'userId'];

function EmailLogs() {
    const location = useLocation();
    const { page, perPage } = parsePaging(location.search);
    const parsedSorting = parseSorting(location.search);
    const sortKey = LOG_SORT_KEYS.includes(parsedSorting.sortKey) ? parsedSorting.sortKey : 'dateTime';
    const sortDirection = parsedSorting.sortDirection || Constants.SORT_DESC;
    const [refetchProps, setRefetchProps] = React.useState({
        perPage,
        page,
        sortKey,
        sortDirection,
    });
    const {
        loading,
        error,
        data,
    } = useExtendedQuery(ALL_EMAIL_LOGS, {
        variables: refetchProps,
    });
    const onPageChange = (newPage) => setRefetchProps({
        ...refetchProps,
        page: newPage,
    });
    const onSort = (newSorting) => setRefetchProps({
        ...refetchProps,
        sortKey: newSorting.key,
        sortDirection: newSorting.direction,
    });
    if (loading) {
        return <Spinner className="email-logs-loading" />;
    }
    if (error) {
        return <Error className="email-logs-error" error={error} />;
    }
    return (
        <Paginator
            totalCount={data.allEmailLogs.emailLogList.totalCount}
            perPage={perPage}
            currentPage={refetchProps.page}
            onPageChange={onPageChange}
            bottom
        >
            <EmailLogsList
                emailLogs={data.allEmailLogs.emailLogList.models}
                onSort={onSort}
                sortingParam={{ key: refetchProps.sortKey, direction: refetchProps.sortDirection }}
            />
        </Paginator>
    );
}

export default EmailLogs;
